import { render, staticRenderFns } from "./AppFacebookPost.vue?vue&type=template&id=3ff68d14"
import script from "./AppFacebookPost.vue?vue&type=script&lang=js"
export * from "./AppFacebookPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports